import React from 'react'
import styles from './styles.module.css'
import useRef from '@hooks/useRef'
import useEffect from '@hooks/useEffect'
import scrollWindowTo from '@helpers/misc/scrollTo'
import classnames from 'classnames'
import Dropdown from './Dropdown'
import useIsStore from '@hooks/useIsStore'

export default function Categories(props) {
  const {activeCategoryId, categories, layout, onClick} = props
  const refs = useRef({}).current
  const container = useRef()
  const isStore = useIsStore()

  const offsetLeft = {
    v1: 40,
    v2: 50,
    mobile: 50
  }[layout]

  const scrollTo = activeCategoryId => {
    const activeElement = refs[activeCategoryId]
    if (!activeElement) return
    scrollWindowTo({
      element: container.current,
      left: activeElement.offsetLeft - offsetLeft
    })
  }

  useEffect(() => {
    if (!activeCategoryId) return
    scrollTo(activeCategoryId)
  }, [activeCategoryId])

  return (
    <div className={styles.container} ref={container}>
      {categories.map(category => {
        const childProps = {
          ref: refs[category._id],
          key: category._id,
          className:
            activeCategoryId === category._id
              ? styles.active
              : classnames(
                  styles.category,
                  global.isDarkBackground ? styles.clearText : styles.darkText
                )
        }

        return isStore ? (
          <Dropdown
            {...childProps}
            id={category._id}
            name={category.name}
            subCategories={category.subCategories}
          />
        ) : (
          <a
            {...childProps}
            onClick={() => {
              onClick()
              props.scrollTo(category._id)
            }}>
            {category.name}
          </a>
        )
      })}
    </div>
  )
}
